import { StringKeys } from "../../resources/strings/StringKeys";
import StripeOnboarding from "../../views/ProtectedViews/StripeOnboarding/StripeOnboarding";
import MobileAppSidebar from "../navbar/MobileAppSidebar";
import { useTranslation } from "react-i18next";

export const CompleteStripeOnboardingRoute = () => {
  const { t } = useTranslation();
  return (
    <>
      <MobileAppSidebar/>
      <div style={{marginTop:"80px", padding:"30px"}}>
        <h2>{t(StringKeys.ONBOARDING_HEADER)}</h2>
        <p>
          {t(StringKeys.ONBOARDING_DESCRIPTION_1)}
          To provide a seamless, efficient experience for managing invoicing, customer creation, and product listings, BiziSmart relies on Stripe as a core part of our service. Stripe's API powers critical features within our platform, allowing us to securely and reliably handle invoicing and financial transactions. Through Stripe, any customers you create and the products you manage are automatically synced, ensuring accuracy and reducing manual data entry.
        </p>
        <p>
          {t(StringKeys.ONBOARDING_DESCRIPTION_2)}
          By completing Stripe onboarding, you gain access to these capabilities, letting you easily handle your finances, track customer purchases, and manage your business's products with confidence. Our integration with Stripe not only simplifies your operations but also meets high standards for security and compliance.
        </p>
        <StripeOnboarding />
      </div>
    </>
  );
};
